import { render, staticRenderFns } from "./vue_universal_table_qrcode.vue?vue&type=template&id=b1e1be7a&scoped=true"
import script from "./vue_universal_table_qrcode.vue?vue&type=script&lang=js"
export * from "./vue_universal_table_qrcode.vue?vue&type=script&lang=js"
import style0 from "./vue_universal_table_qrcode.vue?vue&type=style&index=0&id=b1e1be7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e1be7a",
  null
  
)

export default component.exports